// Cariye Ödeme Yap penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'accounts.makePayment';

export const accountMakePaymentGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Cariye ödeme nasıl yapılır?'),
  intro: t(`${G}.intro`, 'Bu pencere, bir cariye yaptığınız ödemeyi resmi ve izlenebilir şekilde kaydeder. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve cari'),
    body: t(`${G}.regions.body`, 'Ödeme formu'),
    footer: t(`${G}.regions.footer`, 'Tamamla'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Bu ekran ne işe yarar?'),
      text: t(`${G}.s1.text`, 'Cariye yapılan ödemenin tutarını, tarihini ve ödeme kanalını (kasa, banka, kredi kartı, tahakkuk) kayda geçirir. Böylece cari hareket geçmişi, bakiye takibi ve muhasebe raporları doğru oluşur. Üstteki kartta carinin adı ve güncel bakiyesi görünür.'),
      tips: [
        t(`${G}.s1.tip1`, 'Carinin borç / alacak dengesinin doğru güncellenmesini sağlar.'),
        t(`${G}.s1.tip2`, 'Ödemenin hangi kaynaktan (kasa / banka) çıktığını net şekilde gösterir.'),
        t(`${G}.s1.tip3`, 'Belge numarası ve işlem tarihi denetimi, mutabakatı ve raporlamayı kolaylaştırır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Para birimi, ödeme yöntemi ve şube'),
      text: t(`${G}.s2.text`, 'Önce para birimini seçin; kasa, banka ve kart listeleri yalnız bu para birimindeki hesapları gösterir. Sonra ödeme yöntemini seçin: Nakit, Havale/EFT, Kredi Kartı veya Tahakkuk.'),
      tips: [
        t(`${G}.s2.tip1`, 'Şube boş bırakılırsa ("Genel") hareket carinin şubesine yazılır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Paranın çıkacağı yeri seçin'),
      text: t(`${G}.s3.text`, 'Nakitte bir kasa, Havale/EFT\'de bir banka hesabı seçilir; ödenen tutar o kasanın veya banka hesabının bakiyesinden düşer. Bakiye yetmezse kayıt yapılmaz ve uyarı çıkar: başka bir kasa / hesap seçin veya tutarı azaltın.'),
      tips: [
        t(`${G}.s3.tip1`, 'Kredi Kartı: firma kartlarınızdan birini seçin; kartın limiti, kullanılanı ve kalan limiti gösterilir. Tutar kalan limiti aşamaz.'),
        t(`${G}.s3.tip2`, 'Tahakkuk: kasa / banka alanı gizlenir; kasa veya banka bakiyesi değişmez, yalnız cari hareket kaydı oluşur.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Tarih, belge numarası ve tutar'),
      text: t(`${G}.s4.text`, 'İşlem tarihi varsayılan olarak bugündür; ileri veya geri tarihli kayıt yapabilirsiniz. Belge numarası otomatik gelir, dilerseniz değiştirin (ör. TED-2024-001); boş bırakılamaz. Tutarı 1.000,00 biçiminde, sıfırdan büyük girin.'),
      tips: [
        t(`${G}.s4.tip1`, 'Seçilen tarih bugünden 30 günden fazla uzaksa kaydetmeden önce onay istenir.'),
        t(`${G}.s4.tip2`, 'Açıklama isteğe bağlıdır; boş bırakılırsa "… carisine ödeme" yazılır.'),
        t(`${G}.s4.tip3`, 'Proje alanından hareketi bir projeye bağlayabilirsiniz (isteğe bağlı).'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Ödemeyi tamamlayın'),
      text: t(`${G}.s5.text`, '"Ödemeyi Tamamla" düğmesi zorunlu alanlar dolunca açılır. Kayıttan sonra ödeme cari hesaba işlenir ve tediye fişi otomatik açılır; oradan yazdırabilirsiniz. Sağ üstteki (i) bu rehberi yeniden açar.'),
    },
  ],
});
